import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="bg-brand-warm-white text-brand-dark-grey pt-4 pb-10 px-4 overflow-hidden relative" data-id="element-167">
      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-168">
        <div className="animate-fade-in-up" data-id="element-169">
          <div className="max-w-3xl mx-auto" data-id="element-170">
            <div className="inline-block bg-brand-soft-cream text-brand-gold-warm px-5 py-2 rounded-full text-[10px] font-bold mb-4 tracking-[0.2em] uppercase border border-brand-gold-warm/20" data-id="element-171">
              ✨ Aprende a leer el Tarot con confianza
            </div>

            <h1 className="md:text-6xl lg:text-7xl font-extrabold mb-4 text-brand-petroleum tracking-tight text-[28px]" data-id="element-172">
              Convierte las cartas en respuestas claras con el{' '}
              <span className="gold-text-gradient" data-id="element-173">Kit Tarot Listo™</span>
            </h1>
          </div>

          <div className="relative mb-4 max-w-4xl mx-auto" data-id="element-174">
            <img src="https://cdn.magicpatterns.com/uploads/1rNfsoSUmbsZhffYJr5H9X/MOCKUP_PNG.png" alt="Método Tarot Listo Mockup" className="w-full h-auto relative z-10 mockup-shadow" width="800" height="600" fetchpriority="high" data-id="element-175" />
          </div>

          <div className="max-w-2xl mx-auto" data-id="element-176">
            <p className="md:text-xl font-medium mb-4 text-brand-medium-grey text-[14px]" data-id="element-177">
              Comenzá a comprender el lenguaje del Tarot y realizar tus primeras
              lecturas con mayor seguridad desde el primer día. Deja de depender
              del manual y confía en tu intuición.
            </p>
          </div>

          <div className="flex justify-center mb-6" data-id="element-178">
            <CTAButton text="✨ QUIERO EL KIT TAROT LISTO" className="w-full md:w-auto px-12 py-6 text-xl shadow-xl" data-id="element-179" />
          </div>

          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 text-xs font-semibold text-brand-medium-grey uppercase tracking-wider" data-id="element-180">
            <div className="flex items-center gap-2" data-id="element-181">
              <ShieldCheck size={18} className="text-brand-sage-green" data-id="element-182" />
              <span data-id="element-183">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-184">
              <Lock size={18} className="text-brand-sage-green" data-id="element-185" />
              <span data-id="element-186">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-187">
              <CreditCard size={18} className="text-brand-sage-green" data-id="element-188" />
              <span data-id="element-189">Acceso inmediato</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}